import axios from 'axios';
import useSWR from 'swr';
import { useMemo } from 'react';
import { formatAndThrowApiError } from '@/helpers/api';

import { localSwrConfig, fetchData } from '@/helpers/swr';
import { useListEntrySwrConfig } from '@/helpers/_hooks';

const currenciesKey = () => `/currency`;

const useCurrencies = (shouldRevalidate = true) => {
  const swr = useSWR(currenciesKey(), fetchData, shouldRevalidate ? undefined : localSwrConfig);

  return swr;
};

const usePutCurrency = () => {
  const putCurrency = async (uid, payload) => {
    try {
      const url = `/currency/${uid}`;
      const result = await axios.put(url, payload);
      return result.data;
    } catch (error) {
      formatAndThrowApiError(error);
    }
  };

  return putCurrency;
};

const useCurrencyObjectByCode = (code) => {
  const currencies = useSWR(currenciesKey(), fetchData, useListEntrySwrConfig(code));
  return currencies.data.content[code];
};

const useCurrenciesByUid = () => {
  const currencies = useCurrencies(false);
  const currenciesByUid = useMemo(() => {
    return currencies.data.query.reduce((acc, currencyCode) => {
      const currency = currencies.data.content[currencyCode];
      acc[currency.uid] = {
        ...currency
      };
      return acc;
    }, {});
  }, [currencies.data]);
  return currenciesByUid;
};

const useCurrencyObjectByUid = (uid) => {
  const currenciesByUid = useCurrenciesByUid();
  return currenciesByUid[uid];
};

export { useCurrencies, useCurrencyObjectByCode, useCurrencyObjectByUid, useCurrenciesByUid, usePutCurrency };
